import { Props } from 'docz';
import ImageUploadBase from '@emcasa/image-upload/ImageUpload/index.jsx';
import ImageUpload from '@emcasa/image-upload/html5';
import React from 'react';
export default {
  Props,
  ImageUploadBase,
  ImageUpload,
  React
};